import api from '@/api/orderType'
import { errorHandler } from '../exports/error_management'

const state = {
    item: null,
    items: [],
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
}

const actions = {
    async create(context, payload) {
        try {
            await api.create(payload)
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            id = parseInt(id)
            if (!id) {
                context.commit('set_item', null)
                return
            }
            const {
                data: {
                    success: { data },
                },
            } = await api.fetchById(id)
            console.log('fetch item', data)
            context.commit('set_item', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        try {
            const {
                data: {
                    success: { data },
                },
            } = await api.fetchAll()
            console.log('orderType fetchall', data)
            context.commit('set_items', data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        try {
            console.log('update', payload)
            await api.update(payload.id, payload)
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },

    async delete(context, id) {
        try {
            await api.delete(id)
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
